import React from 'react';
import { NavLink } from 'react-router-dom';
import { useRouter } from '../../../hooks/router';

interface Props {
    to: string | { route: string };
    params?: any;
    children: any;
}

export function XLink({ to, params, children }: Props) {
    const path = ((to as any).route || to) as string;
    const { replaceParams } = useRouter();
    const targetPath = replaceParams(path, params);

    if (path.startsWith('http')) {
        return <a href={targetPath}>{children}</a>;
    } else {
        return <NavLink to={targetPath}>{children}</NavLink>;
    }
}
